export default __webpack_public_path__ + "static/media/popgrip.613e769b.jpg";